<template>
    <div class="ion-page">
        <ion-header>
        <ion-toolbar>
            <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
            </ion-buttons>
            <ion-title>Branches List</ion-title>
        </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
        <BranhesAndStations />
        </ion-content>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import BranhesAndStations from "@/components/corporate/branchesAndStations.vue";
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonToolbar } from "@ionic/vue";

export default defineComponent ({
    name: 'branchesAndStations',
    components: {
        BranhesAndStations, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonContent
    },
    data() {
        return {

        }
    },
})
</script>